"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var UITypeaheadResults =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UITypeaheadResults, _PureComponent);

  function UITypeaheadResults() {
    (0, _classCallCheck2.default)(this, UITypeaheadResults);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITypeaheadResults).apply(this, arguments));
  }

  (0, _createClass2.default)(UITypeaheadResults, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          onScroll = _this$props.onScroll,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "onScroll"]);
      return _react.default.createElement("ul", (0, _extends2.default)({}, rest, {
        className: (0, _classnames.default)('private-typeahead-results', className),
        onScroll: onScroll,
        role: "listbox"
      }), children);
    }
  }]);
  return UITypeaheadResults;
}(_react.PureComponent);

exports.default = UITypeaheadResults;
UITypeaheadResults.propTypes = {
  children: _propTypes.default.node,
  onScroll: _propTypes.default.func
};
UITypeaheadResults.displayName = 'UITypeaheadResults';
module.exports = exports.default;